import { PayloadRequestGarantias } from "@interfaces/request";
import { baseApi } from "./baseApi";
import { GarantiasVehicularInmobiliariaResponse, GetGarantiasVehicularInmobiliariaResponse } from "@interfaces/index";

const guaranteesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    postGuaranteesTypes: build.mutation<
      PayloadRequestGarantias,
      { loan_application_id: string; data: PayloadRequestGarantias }
    >({
      query: ({ loan_application_id, data }) => ({
        url: `solicitudes/${loan_application_id}/garantias`,
        method: "POST",
        body: data,
      }),
    }),

    getGuaranteesData: build.query<GarantiasVehicularInmobiliariaResponse[], {loan_application_id: string}>({
      query: ({loan_application_id}) => `solicitudes/${loan_application_id}/garantias`,
      transformResponse: (response: GetGarantiasVehicularInmobiliariaResponse) => {
        return response.data.data;
      },
    }),
  }),
});

export const { usePostGuaranteesTypesMutation, useLazyGetGuaranteesDataQuery } = guaranteesApi;
